import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useFetch from "../../../hooks/useFetch";

const HAFHMessMenuList = ({ t, role, hostelCode }) => {
  const authState = useSelector((state) => state.authReducer);
  const [fetchData] = useFetch();
  const [menus, setMenus] = useState([]);
  const [actionLoading, setActionLoading] = useState(false);
  const [ratingData, setRatingData] = useState({});
  const [wastageData, setWastageData] = useState({});
  const [confirmAction, setConfirmAction] = useState({});
  const [uiMessage, setUiMessage] = useState({type: "",text: "",});
  const [showCloneForm, setShowCloneForm] = useState({});
  const [cloneMenuData, setCloneMenuData] = useState({});

  const [selectedFilter, setSelectedFilter] = useState("ALL");
  const mealFilters = [
    "BREAKFAST",
    "LUNCH",
    "SNACKS",
    "DINNER",
  ];
  const mealTypes = [
    "VEG",
    "NON_VEG",
    "VEGAN",
    "SPECIAL",
  ];

  const fetchMenus = async () => {
    try {
      const res = await fetchData({
        url: "/hafh/operations/mess/menu/all",
        method: "post",
        data: { hostelCode,},
        headers: {Authorization: authState.token,},
      });

      if (res?.status) {
        setMenus(res.records || []);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
      if (hostelCode) {
        fetchMenus();
      }
    }, [hostelCode]);

    useEffect(() => {
    if (!uiMessage.text) return;

    const timer = setTimeout(() => {
      setUiMessage({
        type: "",
        text: "",
      });
    }, 3000);

    return () => clearTimeout(timer);

  }, [uiMessage]);

  const filtered = selectedFilter === "ALL" ? menus : menus.filter(
          (m) => m.mealTiming === selectedFilter || m.mealType === selectedFilter);

  const handleMenuAction = async ({menuId,messId,mealType,actionType,payload = {},}) => {
    try {

      setActionLoading(true);

      const res = await fetchData({
        url: "/hafh/operations/mess/feedback/create",
        method: "post",

        data: {messId, menuId, mealType, actionType, ...payload,},

        headers: {
          Authorization: authState.token,
        },
      });
      if (res?.status) {
        setUiMessage({type: "success",text: "Action submitted successfully",});
        fetchMenus();
      }
    } catch (err) {
      console.error(err);
      setUiMessage({type: "error",text: "Something went wrong",});
    } finally {
      setActionLoading(false);
    }
  };

  const handleCreateMenuLikeThis = async (originalMenu) => {
    try {
      const formData =cloneMenuData[originalMenu._id];

      if (!formData?.mealDate) {
        setUiMessage({type: "error",text: "Please select meal date",});
        return;
      }
      const payload = {
        hostelCode,
        messId: originalMenu.messId,
        messCode: originalMenu.messCode,
        mealDate: new Date(formData.mealDate),
        mealTiming:formData.mealTiming ||originalMenu.mealTiming,
        mealType:formData.mealType ||originalMenu.mealType,
        items:formData.items ||originalMenu.items,
        calories: Number(formData.calories) || 0,
        portionSize:formData.portionSize ||originalMenu.portionSize,
        mealRemarks:formData.mealRemarks ||originalMenu.mealRemarks,
        preparedBy:formData.preparedBy ||originalMenu.preparedBy,
        tags:formData.tags ||originalMenu.tags,
        visibleToRoles:originalMenu.visibleToRoles,
        isPublished: true,
        isSpecialMeal:originalMenu.isSpecialMeal,
      };

      const res = await fetchData({
        url: "/hafh/operations/mess/menu/create",
        method: "post",
        data: payload,
        headers: {Authorization: authState.token,},
      });
      if (res?.status) {
        setUiMessage({type: "success",text: "New menu created successfully",});
        setShowCloneForm((prev) => ({
          ...prev,
          [originalMenu._id]: false,
        }));
        fetchMenus();
      }
    } catch (err) {
      console.error(err);
      setUiMessage({type: "error",text: "Failed to create menu",});
    }
  };

  const sampleMenuTemplates = {
      VEG_BREAKFAST: {
        mealTiming: "BREAKFAST",
        mealType: "VEG",

        items: [
          "Poha",
          "Upma",
          "Idli",
          "Sambar",
          "Coconut Chutney",
          "Banana",
          "Tea",
        ],

        calories: 450,

        portionSize: "Medium",

        mealRemarks:
          "Balanced vegetarian breakfast",

        preparedBy: "Main Kitchen",

        tags: [
          "healthy",
          "protein",
          "morning",
        ],
      },

      NONVEG_BREAKFAST: {
        mealTiming: "BREAKFAST",
        mealType: "NON_VEG",

        items: [
          "Boiled Eggs",
          "Chicken Sausage",
          "Bread Butter",
          "Omelette",
          "Tea",
          "Banana",
        ],

        calories: 650,

        portionSize: "Large",

        mealRemarks:
          "High protein non-veg breakfast",

        preparedBy: "Main Kitchen",

        tags: [
          "protein",
          "nonveg",
          "breakfast",
        ],
      },

      VEG_LUNCH: {
        mealTiming: "LUNCH",
        mealType: "VEG",

        items: [
          "Rice",
          "Dal Fry",
          "Paneer Butter Masala",
          "Chapati",
          "Salad",
          "Papad",
          "Curd",
        ],

        calories: 850,

        portionSize: "Large",

        mealRemarks:
          "Standard vegetarian lunch",

        preparedBy: "Main Kitchen",

        tags: [
          "veg",
          "lunch",
          "balanced",
        ],
      },

      NONVEG_LUNCH: {
        mealTiming: "LUNCH",
        mealType: "NON_VEG",

        items: [
          "Rice",
          "Chicken Curry",
          "Chapati",
          "Dal",
          "Salad",
          "Boiled Egg",
        ],

        calories: 950,

        portionSize: "Large",

        mealRemarks:
          "High protein non-veg lunch",

        preparedBy: "Main Kitchen",

        tags: [
          "nonveg",
          "protein",
          "lunch",
        ],
      },

      SNACKS: {
        mealTiming: "SNACKS",
        mealType: "VEG",

        items: [
          "Veg Sandwich",
          "Samosa",
          "Cookies",
          "Tea",
          "Coffee",
        ],

        calories: 350,

        portionSize: "Medium",

        mealRemarks:
          "Evening refreshments",

        preparedBy: "Snacks Counter",

        tags: [
          "snacks",
          "tea",
          "evening",
        ],
      },
  };

  const loadTemplateIntoForm = (
      menuId,
      templateKey
    ) => {

      const template =
        sampleMenuTemplates[templateKey];

      if (!template) return;

      setShowCloneForm((prev) => ({
        ...prev,
        [menuId]: true,
      }));

      setCloneMenuData((prev) => ({
        ...prev,

        [menuId]: {
          mealDate: "",

          mealTiming: template.mealTiming,

          mealType: template.mealType,

          items: template.items,

          calories: template.calories,

          portionSize: template.portionSize,

          mealRemarks: template.mealRemarks,

          preparedBy: template.preparedBy,

          tags: template.tags,
        },
      }));
  };
  
  return (
    <div className="bg-gray-900 p-5 rounded-xl text-white space-y-4">
      <h2 className="text-cyan-300 text-lg font-bold">🍽 Hostel Mess Menu</h2>
      {uiMessage.text && (
        <div
          className={`rounded-lg px-4 py-3 text-sm font-medium transition-all duration-300 ${
            uiMessage.type === "success"
              ? "bg-green-700 text-green-100 border border-green-500"
              : "bg-red-700 text-red-100 border border-red-500"
          }`}
        >
          {uiMessage.text}
        </div>
      )}
      {/* FILTERS */}
      <div className="grid grid-cols-3 lg:grid-cols-5 gap-1">
        <button
          onClick={() => setSelectedFilter("ALL")}
          className={`px-1 py-2 rounded-md text-xs ${
            selectedFilter === "ALL"
              ? "bg-teal-600"
              : "bg-gray-700"
          }`}
        >
          ALL
        </button>
        {[...mealFilters, ...mealTypes].map(
          (filter) => (
            <button
              key={filter}
              onClick={() =>
                setSelectedFilter(filter)
              }
              className={`px-1 py-2 rounded-md text-xs ${
                selectedFilter === filter
                  ? "bg-teal-600"
                  : "bg-gray-700"
              }`}
            >
              {filter}
            </button>
          )
        )}
      </div>

      {/* LIST */}
      <div className="space-y-3 mt-4">
        {filtered.length === 0 ? (
          <div className="text-gray-200 text-sm">
            No menu available
          </div>
        ) : (
          filtered.map((m) => (
            <div
              key={m._id}
              className="bg-gray-800 p-4 rounded-xl border border-gray-700 space-y-3"
            >
              {/* TOP */}
              <div className="flex justify-between items-start">
                <div>
                  <div className="text-cyan-300 font-semibold">
                    {m.mealTiming}
                  </div>
                  <div className="text-xs text-gray-200 mt-1">
                    📅{" "}
                    {new Date(
                      m.mealDate
                    ).toLocaleDateString()}
                  </div>
                </div>
                <div className="text-xs text-yellow-300">
                  {m.mealType}
                </div>
              </div>
              <div>
                <div className="text-sm text-gray-100 mb-2">
                  Food Items
                </div>
                <div className="flex flex-wrap gap-1">
                  {m.items?.length > 0 ? (
                    m.items.map((item, i) => (
                      <span
                        key={i}
                        className="text-xs bg-gray-700 px-2 py-1 rounded"
                      >
                        🍴 {item}
                      </span>
                    ))
                  ) : (
                    <span className="text-xs text-gray-200">
                      No items listed
                    </span>
                  )}
                </div>
              </div>

              {/* DETAILS */}
              <div className="flex flex-row flex-wrap gap-2 text-xs text-gray-100">
                <div>
                  Calories:{" "}
                  {m.calories || "N/A"}
                </div>
                <div>
                  Portion:{" "}
                  {m.portionSize || "N/A"}
                </div>
                <div>
                  Chef:{" "}
                  {m.preparedBy || "N/A"}
                </div>
                <div>
                  Rating: ⭐{" "}
                  {m.averageRating || 0}
                </div>
              </div>

              {/* SPECIAL FLAGS */}
              <div className="flex flex-wrap gap-2">
                {m.isSpecialMeal && (
                  <span className="text-pink-400 text-xs">
                    🌟 Special Meal
                  </span>
                )}
                {!m.isPublished && (
                  <span className="text-red-400 text-xs">
                    🚫 Unpublished
                  </span>
                )}
              </div>

              {/* REMARKS */}
              {m.mealRemarks && (
                <div className="text-xs text-gray-200">
                  📝 {m.mealRemarks}
                </div>
              )}

              {/* TAGS */}
              {m.tags?.length > 0 && (
                <div className="flex flex-wrap gap-1">
                  {m.tags.map((tag, i) => (
                    <span
                      key={i}
                      className="text-xs bg-gray-700 px-2 py-1 rounded"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>
              )}

              {/* METRICS */}
              <div className="text-xs text-gray-200">
                Rejections:{" "}
                {m.rejectionCount || 0}

                {" | "}

                Wastage Reports:{" "}
                {m.wastageCount || 0}
              </div>

              {/* PLAN LIKE THIS */}
              <div className="pt-2 flex flex-row flex-wrap gap-1">
                <button
                  onClick={() => {
                    setShowCloneForm((prev) => ({
                      ...prev,
                      [m._id]: !prev[m._id],
                    }));
                    setCloneMenuData((prev) => ({
                      ...prev,

                      [m._id]: {
                        mealDate: "",
                        mealTiming: m.mealTiming,
                        mealType: m.mealType,
                        items: m.items,
                        calories: m.calories,
                        portionSize: m.portionSize,
                        mealRemarks: m.mealRemarks,
                        preparedBy: m.preparedBy,
                        tags: m.tags,
                      },
                    }));
                  }}
                  className="w-fit px-1 py-2 bg-emerald-600 hover:bg-emerald-700 rounded-lg text-xs lg:text-sm"
                >
                  📋 Plan Menu Like This
                </button>
                <button
                  onClick={() =>
                    loadTemplateIntoForm(
                      m._id,
                      "VEG_BREAKFAST"
                    )
                  }
                  className="w-fit px-1 py-2 bg-green-700 hover:bg-green-800 rounded-lg text-xs lg:text-sm"
                >
                  🥗 Veg Breakfast
                </button>
                <button
                  onClick={() =>
                    loadTemplateIntoForm(
                      m._id,
                      "NONVEG_BREAKFAST"
                    )
                  }
                  className="w-fit px-1 py-2 bg-red-700 hover:bg-red-800 rounded-lg text-xs lg:text-sm"
                >
                  🍗 Non-Veg Breakfast
                </button>
                <button
                  onClick={() =>
                    loadTemplateIntoForm(
                      m._id,
                      "VEG_LUNCH"
                    )
                  }
                  className="w-fit px-1 py-2 bg-teal-700 hover:bg-teal-800 rounded-lg text-xs lg:text-sm"
                >
                  🍛 Veg Lunch/Dinner
                </button>
                <button
                  onClick={() =>
                    loadTemplateIntoForm(
                      m._id,
                      "NONVEG_LUNCH"
                    )
                  }
                  className="w-fit px-1 py-2 bg-orange-700 hover:bg-orange-800 rounded-lg text-xs lg:text-sm"
                >
                  🍖 Non-Veg Lunch/Dinner
                </button>
                <button
                  onClick={() =>
                    loadTemplateIntoForm(
                      m._id,
                      "SNACKS"
                    )
                  }
                  className="w-fit px-1 py-2 bg-purple-700 hover:bg-purple-800 rounded-lg text-xs lg:text-sm"
                >
                  ☕ Snacks / High Tea
                </button>
              </div>

              {/* CLONE MENU FORM */}
              {showCloneForm[m._id] && (
                <div className="bg-gray-900 border border-emerald-700 rounded-xl p-4 mt-3 space-y-4">
                  <div className="text-emerald-300 font-semibold">
                    Create New Menu Using This Template
                  </div>
                  <div>
                    <label className="text-xs text-gray-300">
                      Meal Date
                    </label>
                    <input
                      type="date"
                      value={
                        cloneMenuData[m._id]?.mealDate || ""
                      }
                      onChange={(e) =>
                        setCloneMenuData((prev) => ({
                          ...prev,
                          [m._id]: {
                            ...prev[m._id],
                            mealDate: e.target.value,
                          },
                        }))
                      }
                      className="w-full mt-1 bg-gray-800 border border-gray-700 rounded-lg px-3 py-2 text-sm"
                    />
                  </div>
                 <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="text-xs text-gray-300">
                        Meal Timing
                      </label>
                      <select
                        value={
                          cloneMenuData[m._id]?.mealTiming
                        }
                        onChange={(e) =>
                          setCloneMenuData((prev) => ({
                            ...prev,
                            [m._id]: {
                              ...prev[m._id],
                              mealTiming: e.target.value,
                            },
                          }))
                        }
                        className="w-full mt-1 bg-gray-800 border border-gray-700 rounded-lg px-2 py-1 text-sm"
                      >
                        {mealFilters.map((meal) => (
                          <option
                            key={meal}
                            value={meal}
                          >
                            {meal}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="text-xs text-gray-300">
                        Meal Type
                      </label>

                      <select
                        value={
                          cloneMenuData[m._id]?.mealType
                        }
                        onChange={(e) =>
                          setCloneMenuData((prev) => ({
                            ...prev,
                            [m._id]: {
                              ...prev[m._id],
                              mealType: e.target.value,
                            },
                          }))
                        }
                        className="w-full mt-1 bg-gray-800 border border-gray-700 rounded-lg px-2 py-1 text-sm"
                      >
                        {mealTypes.map((type) => (
                          <option
                            key={type}
                            value={type}
                          >
                            {type}
                          </option>
                        ))}
                      </select>
                    </div>

                  </div>

                  {/* ITEMS */}

                  <div>
                    <label className="text-xs text-gray-300">
                      Food Items (comma separated)
                    </label>

                    <textarea
                      style={{height: "150px"}}
                      value={
                        cloneMenuData[m._id]?.items?.join(
                          ", "
                        ) || ""
                      }
                      onChange={(e) =>
                        setCloneMenuData((prev) => ({
                          ...prev,
                          [m._id]: {
                            ...prev[m._id],

                            items: e.target.value
                              .split(",")
                              .map((x) => x.trim()),
                          },
                        }))
                      }
                      className="w-full mt-1 bg-gray-800 border border-gray-700 rounded-lg px-3 py-2 text-sm"
                    />
                  </div>

                  {/* CALORIES + PORTION */}

                  <div className="grid grid-cols-2 gap-3">

                    <div>
                      <label className="text-xs text-gray-300">
                        Calories
                      </label>

                      <input
                        type="number"
                        value={
                          cloneMenuData[m._id]?.calories || ""
                        }
                        onChange={(e) =>
                          setCloneMenuData((prev) => ({
                            ...prev,
                            [m._id]: {
                              ...prev[m._id],
                              calories: e.target.value,
                            },
                          }))
                        }
                        className="w-full mt-1 bg-gray-800 border border-gray-700 rounded-lg px-3 py-2 text-sm"
                      />
                    </div>

                    <div>
                      <label className="text-xs text-gray-300">
                        Portion Size
                      </label>

                      <input
                        type="text"
                        value={
                          cloneMenuData[m._id]
                            ?.portionSize || ""
                        }
                        onChange={(e) =>
                          setCloneMenuData((prev) => ({
                            ...prev,
                            [m._id]: {
                              ...prev[m._id],
                              portionSize: e.target.value,
                            },
                          }))
                        }
                        className="w-full mt-1 bg-gray-800 border border-gray-700 rounded-lg px-3 py-2 text-sm"
                      />
                    </div>

                  </div>

                  {/* REMARKS */}

                  <div>
                    <label className="text-xs text-gray-300">
                      Remarks
                    </label>

                    <textarea
                      style={{height: "150px"}}
                      value={
                        cloneMenuData[m._id]
                          ?.mealRemarks || ""
                      }
                      onChange={(e) =>
                        setCloneMenuData((prev) => ({
                          ...prev,
                          [m._id]: {
                            ...prev[m._id],
                            mealRemarks: e.target.value,
                          },
                        }))
                      }
                      className="w-full mt-1 bg-gray-800 border border-gray-700 rounded-lg px-3 py-2 text-sm"
                    />
                  </div>

                  <div className="flex justify-end">
                    <button
                      onClick={() =>
                        handleCreateMenuLikeThis(m)
                      }
                      className="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 rounded-lg text-sm"
                    >
                      ✅ Create New Menu
                    </button>
                  </div>
                </div>
              )}

              {/* ACTIONS */}
              <div className="space-y-4 mt-3">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                  <div className="bg-gray-900 border border-gray-700 rounded-lg p-2 space-y-2">
                    <div className="text-xs text-yellow-300 font-semibold">
                      ⭐ Rate Meal
                    </div>

                    <div className="flex flex-row gap-1">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <button
                          key={star}
                          onClick={() =>
                            setRatingData((prev) => ({
                              ...prev,
                              [m._id]: star,
                            }))
                          }
                          className={`w-6 p-1 text-lg ${
                            (ratingData[m._id] || 0) >= star
                              ? "text-yellow-400"
                              : "text-gray-200"
                          }`}
                        >
                          ★
                        </button>
                      ))}
                    </div>

                    <button
                      disabled={!ratingData[m._id] || actionLoading}
                      onClick={() =>
                        handleMenuAction({
                          menuId: m._id,
                          messId: m.messId,
                          mealType: m.mealTiming,
                          actionType: "RATING",

                          payload: {
                            rating: ratingData[m._id],
                          },
                        })
                      }
                      className="w-32 lg:w-40 text-xs lg:text-sm px-2 py-1 bg-yellow-600 rounded"
                    >
                      Submit Rating
                    </button>
                  </div>

                  <div className="bg-gray-900 border border-gray-700 rounded-lg p-2 space-y-2">
                    <div className="text-xs text-red-300 font-semibold">
                      🚫 Reject Meal
                    </div>
                    <button
                      onClick={() =>
                        setConfirmAction((prev) => ({
                          ...prev,
                          [m._id]:
                            prev[m._id] === "REJECT"
                              ? ""
                              : "REJECT",
                        }))
                      }
                      className="w-32 lg:w-40 text-xs lg:text-sm  px-2 py-1 bg-red-600 rounded "
                    >
                      Reject
                    </button>

                    {confirmAction[m._id] === "REJECT" && (
                      <button
                        disabled={actionLoading}
                        onClick={() =>
                          handleMenuAction({
                            menuId: m._id,
                            messId: m.messId,
                            mealType: m.mealTiming,
                            actionType: "REJECT",

                            payload: {
                              isRejected: true,
                            },
                          })
                        }
                        className="w-32 lg:w-40 text-xs lg:text-sm  px-2 py-1 bg-red-800 rounded"
                      >
                        Confirm Reject
                      </button>
                    )}
                  </div>

                  <div className="bg-gray-900 border border-gray-700 rounded-lg p-2 space-y-2">
                    <div className="text-xs text-blue-300 font-semibold">
                      🍽 Meal Consumed
                    </div>
                    <button
                      onClick={() =>
                        setConfirmAction((prev) => ({
                          ...prev,
                          [m._id]:
                            prev[m._id] === "CONSUMED"
                              ? ""
                              : "CONSUMED",
                        }))
                      }
                      className="w-32 lg:w-40 text-xs lg:text-sm px-2 py-1 bg-blue-600 rounded"
                    >
                      Mark Consumed
                    </button>

                    {confirmAction[m._id] === "CONSUMED" && (
                      <button
                        disabled={actionLoading}
                        onClick={() =>
                          handleMenuAction({
                            menuId: m._id,
                            messId: m.messId,
                            mealType: m.mealTiming,
                            actionType: "CONSUMED",

                            payload: {
                              isConsumed: true,
                            },
                          })
                        }
                        className="w-32 lg:w-40 text-xs lg:text-sm px-2 py-1 bg-blue-800 rounded"
                      >
                        Confirm Consumed
                      </button>
                    )}
                  </div>

                  {/* WASTAGE */}
                  <div className="flex flex-col bg-gray-900 border border-gray-700 rounded-lg p-2 space-y-2">

                    <div className="text-xs text-purple-300 font-semibold">
                      ♻ Report Wastage
                    </div>

                    <input
                      type="number"
                      min="0"
                      max="100"
                      placeholder="%"
                      value={wastageData[m._id]?.percentage || ""}
                      onChange={(e) =>
                        setWastageData((prev) => ({
                          ...prev,
                          [m._id]: {
                            ...prev[m._id],
                            percentage: e.target.value,
                          },
                        }))
                      }
                      className="w-full bg-gray-800 border border-gray-700 rounded px-2 py-1 text-xs"
                    />

                    <textarea
                      style={{height: "150px", width: "100%"}}
                      placeholder="Remarks..."
                      value={wastageData[m._id]?.remarks || ""}
                      onChange={(e) =>
                        setWastageData((prev) => ({
                          ...prev,
                          [m._id]: {
                            ...prev[m._id],
                            remarks: e.target.value,
                          },
                        }))
                      }
                      className="text-xs lg:text-sm bg-gray-800 border border-gray-700 rounded px-2 py-1"
                    />

                    <button
                      disabled={
                        !wastageData[m._id]?.percentage ||
                        actionLoading
                      }
                      onClick={() =>
                        handleMenuAction({
                          menuId: m._id,
                          messId: m.messId,
                          mealType: m.mealTiming,
                          actionType: "WASTAGE",

                          payload: {
                            wasteReported: true,

                            wastePercentage:
                              Number(wastageData[m._id]?.percentage),

                            reason:
                              wastageData[m._id]?.remarks,
                          },
                        })
                      }
                      className="w-32 lg:w-40 text-xs lg:text-sm  px-2 py-1 bg-purple-600 rounded"
                    >
                      Submit Wastage
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default HAFHMessMenuList;